// extracted by mini-css-extract-plugin
module.exports = {"arrow":"_1410bfd27b--arrow--fO_dm","icon-wrapper":"_1410bfd27b--icon-wrapper--k90xO"};